import { render, staticRenderFns } from "./StockHistory.vue?vue&type=template&id=9abf3436"
import script from "./StockHistory.vue?vue&type=script&lang=js"
export * from "./StockHistory.vue?vue&type=script&lang=js"
import style0 from "./StockHistory.vue?vue&type=style&index=0&id=9abf3436&prod&lang=scss&scpoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports